export const WEEK_HEIGHT = 72;
export const EVENT_CIRCLE = 18;

export const DAYS_PER_WEEK = 7.5;
export const FEB_DAYS_PER_WEEK = 7;

export const RANGE_WK1 = [1, 7];
export const RANGE_WK2 = [8, 15];
export const RANGE_WK3 = [16, 23];
export const RANGE_WK4 = [24, 31];
export const MONTH_WITH_30_DAYS_RANGE_WK4 = [24, 30];

export const FEB_RANGE_WK1 = [1, 7];
export const FEB_RANGE_WK2 = [8, 14];
export const FEB_RANGE_WK3 = [15, 22];
export const FEB_RANGE_WK4 = [23, 28];
export const FEB_LEAP_YEAR_RANGE_WK4 = [23, 29];

export const SINGAPORE_HOLIDAYS: readonly string[] = [
  // ===== 2022 =====
  '2022-01-01', // New Year's Day
  '2022-02-01', // Chinese New Year
  '2022-02-02', // Chinese New Year Holiday
  '2022-04-15', // Good Friday
  '2022-05-01', // Labour Day
  '2022-05-02', // Hari Raya Puasa
  '2022-05-03', // Labour Day Holiday
  '2022-05-15', // Vesak Day
  '2022-05-16', // Vesak Day Holiday
  '2022-07-10', // Hari Raya Haji
  '2022-07-11', // Hari Raya Haji Holiday
  '2022-08-09', // National Day
  '2022-10-24', // Deepavali
  '2022-12-25', // Christmas Day
  '2022-12-26', // Christmas Holiday

  // ===== 2023 =====
  '2023-01-01', // New Year's Day
  '2023-01-02', // New Year's Holiday
  '2023-01-22', // Chinese New Year
  '2023-01-23', // Chinese New Year Holiday
  '2023-01-24', // Chinese New Year Additional Holiday
  '2023-04-07', // Good Friday
  '2023-04-22', // Hari Raya Puasa
  '2023-05-01', // Labour Day
  '2023-06-02', // Vesak Day
  '2023-06-29', // Hari Raya Haji
  '2023-08-09', // National Day
  '2023-11-12', // Deepavali
  '2023-11-13', // Deepavali Holiday
  '2023-12-25', // Christmas Day

  // ===== 2024 =====
  '2024-01-01', // New Year's Day
  '2024-02-10', // Chinese New Year
  '2024-02-11', // Chinese New Year Holiday
  '2024-02-12', // Chinese New Year Additional Holiday
  '2024-03-29', // Good Friday
  '2024-04-10', // Hari Raya Puasa
  '2024-05-01', // Labour Day
  '2024-05-22', // Vesak Day
  '2024-06-16', // Hari Raya Haji
  '2024-08-09', // National Day
  '2024-10-31', // Deepavali
  '2024-12-25', // Christmas Day

  // ===== 2025 =====
  '2025-01-01', // New Year's Day
  '2025-01-29', // Chinese New Year
  '2025-01-30', // Chinese New Year Holiday
  '2025-03-30', // Hari Raya Puasa
  '2025-04-18', // Good Friday
  '2025-05-01', // Labour Day
  '2025-05-12', // Vesak Day
  '2025-06-07', // Hari Raya Haji
  '2025-08-09', // National Day
  '2025-10-20', // Deepavali
  '2025-12-25', // Christmas Day

  // ===== 2026 =====
  '2026-01-01', // New Year's Day
  '2026-02-17', // Chinese New Year
  '2026-02-18', // Chinese New Year Holiday
  '2026-03-21', // Hari Raya Puasa
  '2026-04-03', // Good Friday
  '2026-05-01', // Labour Day
  '2026-05-27', // Hari Raya Haji
  '2026-08-09', // National Day
  '2026-11-09', // Deepavali
  '2026-12-25', // Christmas Day

  // ===== 2027 =====
  '2027-01-01', // New Year's Day
  '2027-02-06', // Chinese New Year
  '2027-02-07', // Chinese New Year Holiday
  '2027-03-26', // Good Friday
  '2027-03-10', // Hari Raya Puasa
  '2027-05-01', // Labour Day
  '2027-05-21', // Vesak Day
  '2027-05-17', // Hari Raya Haji
  '2027-08-09', // National Day
  '2027-10-29', // Deepavali
  '2027-12-25', // Christmas Day
] as const;
